import { useState } from "react";
import { Link } from "react-router-dom";

export function MobileNav({ prefix = "/", active }) {
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);
  const cls = (key) =>
    `block px-4 py-2.5 rounded border text-xs font-ui font-semibold transition-colors ${
      active === key
        ? "bg-white text-[#0284c7] border-[#38bdf8]"
        : "bg-white text-[#0f172a] border-[#cbd5e1]"
    }`;
  return (
    <div className="sm:hidden" data-testid="mobile-nav">
      <button
        type="button"
        data-testid="mobile-nav-toggle"
        onClick={() => setOpen((v) => !v)}
        aria-label="Apri menu"
        className="w-10 h-10 rounded bg-white border border-[#cbd5e1] flex items-center justify-center text-[#0f172a]"
      >
        {open ? (
          <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" aria-hidden="true">
            <path d="M6 6l12 12M18 6L6 18" strokeLinecap="round" />
          </svg>
        ) : (
          <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" aria-hidden="true">
            <path d="M4 7h16M4 12h16M4 17h16" strokeLinecap="round" />
          </svg>
        )}
      </button>
      {open && (
        <div
          data-testid="mobile-nav-panel"
          className="absolute right-4 top-full mt-2 w-56 bg-white border border-[#e2e8f0] rounded-xl shadow-lg p-2 flex flex-col gap-2 z-50"
        >
          <a href={`${prefix}#calendari`} data-testid="mnav-calendari" onClick={close} className={cls("calendari")}>
            Calendari Gare
          </a>
          <Link to="/circoli" data-testid="mnav-circoli" onClick={close} className={cls("circoli")}>
            Circoli
          </Link>
          <Link to="/galleria" data-testid="mnav-galleria" onClick={close} className={cls("galleria")}>
            Galleria foto
          </Link>
          <a href={`${prefix}#regolamento`} data-testid="mnav-regolamento" onClick={close} className={cls("regolamento")}>
            Regolamento
          </a>
          <Link to="/modulistica" data-testid="mnav-modulistica" onClick={close} className={cls("modulistica")}>
            Modulistica
          </Link>
          <Link
            to="/admin"
            data-testid="mnav-login"
            onClick={close}
            className="block px-4 py-2.5 rounded text-xs font-ui font-bold uppercase tracking-wider bg-[#38bdf8] text-[#0f172a] text-center"
          >
            Login Admin
          </Link>
        </div>
      )}
    </div>
  );
}
